/* dev-prelaunch-hero.js */

(() => {
  const SELECTOR = '.dev-prelaunch-hero';

  // Namespaced per form: the launch popup captures the same signup on this same
  // page and keys its own Lead separately, so neither can consume the other's.
  const PENDING_EMAIL_KEY = 'rgd:lead-email--prelaunch-hero';

  // "Join the Waitlist" doesn't navigate away — it brings the visitor to the
  // email field and focuses it so they can enter their address inline.
  function wireWaitlist(section) {
    const trigger = section.querySelector('[data-waitlist-trigger]');
    if (!trigger || trigger.dataset.waitlistBound) return;
    trigger.dataset.waitlistBound = 'true';

    trigger.addEventListener('click', (event) => {
      // Prefer the email input; after a successful submit it's gone, so fall
      // back to the success message / card so the click still lands somewhere.
      const target =
        section.querySelector('[name="contact[email]"]') ||
        section.querySelector('[data-success]') ||
        section.querySelector('.dev-prelaunch-hero__card');
      if (!target) return; // let the href anchor handle it

      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (typeof target.focus === 'function') target.focus({ preventScroll: true });
    });
  }

  function wireEmailCapture(section) {
    const form = section.querySelector('form');
    if (!form || form.dataset.leadBound) return;
    form.dataset.leadBound = 'true';

    form.addEventListener('submit', () => {
      // This {% form %} is given an id, so Shopify points its action at
      // /contact#<that id>. Fragments never reach the server, but the browser
      // carries them across the redirect, so the visitor lands on
      // ?customer_posted=true#PrelaunchHero-… and gets yanked down the page.
      // The action is read after this handler runs, so dropping it here is
      // enough. The popup passes no id and so has no anchor to strip.
      form.action = form.action.split('#')[0];

      const input = form.querySelector('[name="contact[email]"]');
      if (input) window.RGDLead.remember(PENDING_EMAIL_KEY, input.value);
    });
  }

  function initAll(root) {
    const scope = root || document;
    scope.querySelectorAll(SELECTOR).forEach((section) => {
      wireWaitlist(section);
      wireEmailCapture(section);
    });

    // If the page reloaded after a successful submit, move focus to the
    // success message for screen-reader users. preventScroll because a bare
    // focus() also scrolls the element into view — role="status" announces it
    // either way, so the jump buys nothing.
    const success = scope.querySelector(`${SELECTOR} [data-success]`);
    if (success) success.focus({ preventScroll: true });

    // Shopify renders this success state from ?customer_posted=true alone, so
    // it shows up when the popup was the form submitted too, and when someone
    // simply opens that URL. RGDLead.track stays silent unless this session
    // actually submitted THIS form.
    if (success) window.RGDLead.track(PENDING_EMAIL_KEY, 'Pre Launch Waitlist');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  // Theme editor support.
  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
